module.exports = __webpack_public_path__ + "static/undraw_feeling_proud_qne1-5b68153247a5ad038801fa3ebc81caea.svg";